import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

interface Randomizer {
  id: string
  version: string
}

// RefRandomizer stays on v1: the v2 ref-data DTO does not expose `version`.
export default async function getRandomizerTypeId(version: string): Promise<string> {
  try {
    const response = await apiClient.get(endpoints.randomizerVersion)
    const randomizer = unwrapCollection<Randomizer>(response).find(r => r.version === version)

    if (!randomizer) {
      throw new Error(`No se encontró randomizer para la versión ${version}`)
    }

    return randomizer.id
  } catch (error) {
    throw new Error(
      `No se pudo obtener randomizerTypeId para versión ${version}: ${error instanceof Error ? error.message : 'Error desconocido'}`,
    )
  }
}
